/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { groupDataSchema } from "../groupDataSchema.ts";
import { z } from "zod";

export const getRealmSoftwaresHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description La liste des logiciels est retournée avec succès.
 */
export const getRealmSoftwares200Schema = z.array(z.lazy(() => groupDataSchema).describe("Liste des logiciels attribués au membre dans l'organisation"))

/**
 * @description Réponse d\'erreur standard
 */
export const getRealmSoftwares500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getRealmSoftwaresQueryResponseSchema = z.lazy(() => getRealmSoftwares200Schema)